import { useState } from 'react';

import { useUsersActions } from 'system/hooks';
import { mapUserSettingDataToSend } from 'system/mappers';
import { ISystemUser } from 'system/types';

import UserSettingView from './UserSettingView';

interface IProps {
  user: ISystemUser;
}

const UserSetting = ({ user }: IProps) => {
  const [checked, setChecked] = useState(
    '1' === user.allowQuoteReleaseWithoutSendingEmail
  );

  const { editUserSettings, editUserSettingsIsLoading } = useUsersActions();

  const onAllowQuoteReleaseWithoutSendingEmailChange = async (
    event,
    userId: number
  ) => {
    try {
      await editUserSettings(
        mapUserSettingDataToSend(userId, event.target.checked)
      );

      setChecked(!checked);
    } catch (error) {}
  };

  return (
    <UserSettingView
      checked={checked}
      user={user}
      isLoading={editUserSettingsIsLoading}
      onAllowQuoteReleaseWithoutSendingEmailChange={
        onAllowQuoteReleaseWithoutSendingEmailChange
      }
    />
  );
};

export default UserSetting;
